const PlayVideo = ({ video }) => {
  return (
    <video autoPlay muted loop width="100%" height="100%" preload="auto">
      <source src={video} type="video/webm" />
    </video>
  );
};
export default PlayVideo;
